var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2_1615)","key":0},React.createElement("path",{"d":"M11.9994 13.0731L22.9097 23.9834L23.9703 22.9227L13.0601 12.0125L23.9994 1.07311L22.9387 0.0124512L11.9994 10.9518L1.06005 0.0124512L-0.000610352 1.07311L10.9387 12.0125L0.0284691 22.9227L1.08913 23.9834L11.9994 13.0731Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2_1615"},React.createElement("rect",{"width":"24","height":"24","fill":"currentColor"})))]);
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
